import { useCallback } from "react";
import { getCommitmentByGuid } from "../../services/requestServices";

export function useQueryCommitment({state, dispatch}) {
  const { commitment } = state;

  const request = useCallback(async (childId) => {
    if (commitment.status === "success") {
      return commitment.data;
    }

    dispatch({type: "setCommitmentStatus", payload: "loading"});

    try {
      const data = await getCommitmentByGuid(childId);
      dispatch({type: "setCommitmentData", payload: data});
      dispatch({type: "setCommitmentStatus", payload: "success"});
      return data;
    } catch (err) {
      // Implement Error Handling
      dispatch({ type: "setCommitmentStatus", payload: "error" });
      return Promise.reject(err);
    }
  }, [dispatch]);

  return {
    ...commitment,
    request,
    isPending: commitment.status === "pending",
    isLoading: commitment.status === "loading",
    isWaiting: ["loading", "pending"].includes(commitment.status),
    isError: commitment.status === "error",
    isSuccess: commitment.status === "success",
    isComplete: ["success", "error"].includes(commitment.status)
  }
}

export default useQueryCommitment;